export const SET_MFA_SETUP = 'SET_MFA_SETUP'
export const SET_MFA_SETUP_RECOVERY_KEY = 'SET_MFA_SETUP_RECOVERY_KEY'
export const RESET_MFA_SETUP_RECOVERY_KEY = 'RESET_MFA_SETUP_RECOVERY_KEY'
export const RESET_MFA = 'SET_MFA'
